import React from 'react';


const Warning = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 25 24" fill="none">
        <circle cx="12.959" cy="12" r="12" fill="#FFF7E8" />
        <mask id="warning-mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="6" y="5" width="14" height="14">
            <path fillRule="evenodd" clipRule="evenodd" d="M12.9568 5.14258C9.17161 5.14258 6.09961 8.21458 6.09961 11.9997C6.09961 15.7849 9.17161 18.8569 12.9568 18.8569C16.7419 18.8569 19.8139 15.7849 19.8139 11.9997C19.8139 8.21458 16.7419 5.14258 12.9568 5.14258ZM13.646 15.4285H12.2746V14.0571H13.646V15.4285ZM13.646 12.6858H12.2746V8.57156H13.646V12.6858Z" fill="white" />
        </mask>
        <g mask="url(#warning-mask0)">
            <rect x="-4.01367" y="-4.97168" width="34.4571" height="34.4571" fill="#FFC248" />
            <mask id="warning-mask1" mask-type="alpha" maskUnits="userSpaceOnUse" x="-5" y="-5" width="36" height="35">
                <rect x="-4.01367" y="-4.97168" width="34.4571" height="34.4571" fill="white" />
            </mask>
            <g mask="url(#warning-mask1)">
            </g>
        </g>
    </svg>
);

export default Warning;